module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-ons-page', {
    staticClass: "l-content l-contact"
  }, [_c('custom-toolbar', {
    attrs: {
      "backLabel": "Retour"
    }
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm._l((_vm.region.categories), function(category, index_category) {
    return _c('div', {
      key: index_category,
      staticClass: "category"
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(_vm.$t(category.name)))]), _vm._v(" "), _vm._l((category.contacts), function(contact, index_contact) {
      return _c('div', {
        key: index_contact,
        staticClass: "infoContent"
      }, [_c('h2', [_vm._v(_vm._s(_vm.$t(contact.name)))]), _vm._v(" "), (contact.address) ? _c('div', {
        staticClass: "info"
      }, [_c('i', {
        staticClass: "fas fa-map-marker-alt"
      }), _vm._v(" "), _c('div', {
        staticClass: "infoName"
      }, [_c('span', {
        domProps: {
          "innerHTML": _vm._s(contact.address)
        }
      }), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(contact.zip) + " " + _vm._s(contact.city) + "\n        ")])]) : _vm._e(), _vm._v(" "), (contact.tel) ? _c('div', {
        staticClass: "info"
      }, [_c('i', {
        staticClass: "fas fa-phone"
      }), _vm._v(" "), _c('div', {
        staticClass: "infoName"
      }, [_c('a', {
        attrs: {
          "href": 'tel:' + contact.tel
        }
      }, [_vm._v(_vm._s(contact.tel))])])]) : _vm._e(), _vm._v(" "), (contact.email) ? _c('div', {
        staticClass: "info"
      }, [_c('i', {
        staticClass: "fas fa-envelope"
      }), _vm._v(" "), _c('div', {
        staticClass: "infoName"
      }, [_vm._v(_vm._s(contact.email))])]) : _vm._e()])
    })], 2)
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-755f29d1","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/EmergencyRegion.vue
// module id = 220
// module chunks = 0